export default {
  routes: [
    {
      name: 'roles',
      path: '/admin/roles',
      component: () => import('./views/TheRoles.vue'),

    },

    {
      name: 'role',
      path: '/admin/roles/:uuid',
      component: () => import('./views/TheRole.vue'),
    },
  ]
}
